import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=7d801097"
import script from "./SubHeader.vue?vue&type=script&lang=ts"
export * from "./SubHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports